var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    style: {
      stroke: "rgb(155, 155, 155)",
      height: 14,
      width: 14
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeLinecap: "round",
    d: "M7.79 7l5.05 5.05a.56.56 0 11-.8.79L7 7.79l-5.05 5.05a.56.56 0 11-.79-.8L6.21 7 1.16 1.95a.56.56 0 11.8-.79L7 6.21l5.05-5.05a.56.56 0 11.79.8L7.79 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ce1ba515c15511cea655076eb94717c0.svg";
export { ForwardRef as ReactComponent };